import actions from '@/locale/langs/de/actions';
import attributes from '@/locale/langs/de/attributes';
import resources from '@/locale/langs/de/resources';
export default {
    actions: actions,
    attributes: attributes,
    resources: resources,
};
